import * as R from "ramda";
import { Icon, message, Upload } from "antd";
import React, { useEffect, useState } from "react";

import {
  sizeToHumanReadableSize,
  isLessThanHumanReadableSize,
} from "./upload-resource-util";
import {
  AcceptTextTypes,
  getSingleFileListByUrl,
  uploadResourceVideoLimit,
} from "./upload-resource-modal";
import useCustomRequest from "./useCustomRequest";
import { LazyImage } from "@/components/lazyImage/lazy-image";

import "./upload-resource.scss";

//  https://cdnresources.jimage.cn/bgimg/113691732615939_.pic.jpg
export const showMediaOssUrl = "//resources.jimage.cn/";
export const previewMediaOssBaseUrlWithCdn = "//cdnresources.jimage.cn/";
export const uploadMediaOssUrl =
  "//jfoto-media-resources.oss-cn-beijing.aliyuncs.com/";
//  //jfoto-media-resources.oss-cn-beijing.aliyuncs.com/

export const beforeUploadCheckFail = "before-upload-check-fail";

/**
 * 普通上传, 显示进度条
 */
export const UploadResourceFile = (props) => {
  const { onProgress = R.T, value } = props;
  const customRequest = useCustomRequest(props);
  const type = props.type;
  const [loading, setLoading] = useState(false);

  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (value && value.fileList) {
      setFileList(value.fileList);
    }
  }, [value]);

  const imageUrl = R.pathOr("", ["value", "fileList", 0, "url"], props);

  const isImage = type === "image";
  return (
    <Upload
      {...props}
      className={
        props.className
          ? `${props.className} upload-resource-container`
          : "upload-resource-container"
      }
      customRequest={customRequest}
      showUploadList={isImage ? false : { showPreviewIcon: true }}
      action={uploadMediaOssUrl}
      multiple={false}
      fileList={fileList}
      listType={type === "image" ? "picture-card" : undefined}
      onChange={(info) => {
        if (
          R.pipe(
            R.pathOr("", ["file", "status"]),
            R.equals(beforeUploadCheckFail)
          )(info)
        ) {
          setFileList([]);
          props.onChange({
            fileList: [],
          });
          return;
        }
        if (info.file.status === "uploading") {
          setLoading(true);
        }
        if (info.file.status === "done") {
          setLoading(false);
        }
        if (info.file.status === "error") {
          setLoading(false);
          message.error(`${info.file.name} 上传失败`);
        }
        if (info.file.status !== beforeUploadCheckFail) {
          setFileList(info.fileList);
        }
        //  这儿这样写的目的是为了让外部能够获取到最新的fileList, 因为multiple为false, 所以fileList只有一个元素
        props.onChange({
          fileList: [info.file],
        });
      }}
      beforeUpload={(file) => {
        let isValid = false;
        switch (type) {
          case "video":
            isValid =
              file.type.includes("video") &&
              isLessThanHumanReadableSize(file.size, uploadResourceVideoLimit);
            break;
          case "audio":
            isValid =
              file.type.includes("audio") &&
              isLessThanHumanReadableSize(file.size, "1G");
            break;
          case "image":
            isValid =
              file.type.includes("image") &&
              isLessThanHumanReadableSize(file.size, "30M");
            break;
          case "text":
            const extension = file.name
              .substring(file.name.lastIndexOf(".") + 1)
              .toLowerCase();
            isValid =
              AcceptTextTypes.includes(extension) &&
              isLessThanHumanReadableSize(file.size, "1G");
            break;
          default:
            message.error(
              `仅支持视频, 音频, 图片, 文本, 当前文件类型为${file.type}`
            );
            return false;
        }
        if (!isValid) {
          message.error(
            `请上传符合要求的文件,当前文件类型为${
              file.type
            }, 文件大小:${sizeToHumanReadableSize(file.size)}`
          );
          file.status = beforeUploadCheckFail;
          setFileList([]);
          return false;
        }
        return true;
      }}
      onProgress={onProgress}
    >
      {
        //  如果是图片, 则不显示进度条
        isImage ? (
          imageUrl ? (
            <LazyImage src={imageUrl} alt="avatar" style={{ width: "100%" }} />
          ) : (
            <div>
              <Icon type={loading ? "loading" : "plus"} />
              <div className="ant-upload-text">上传</div>
            </div>
          )
        ) : (
          <Icon
            type="upload"
            style={{ fontSize: 24 }}
            className="cursor-pointer"
          />
        )
      }
    </Upload>
  );
};

export const UploadImageByStringUrl = (props) => {
  const { onChange = R.T, value } = props;
  const [fileList, setFileList] = useState(getSingleFileListByUrl(value));
  return (
    <UploadResourceFile
      {...props}
      value={{ fileList }}
      onChange={(info) => {
        //  onChange(info.fileList[0].url); // 为了保证url能用, 需要延迟一下, 暂定为 500ms
        setTimeout(() => {
          onChange(info.fileList[0].url);
        }, 500);
        setFileList(info.fileList);
      }}
      type="image"
    />
  );
};



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/upload-resource.js